import React from 'react';
import { useNavigate } from 'react-router-dom';

function FormActions({
  templateType,
  formData,
  saving,
  downloading,
  graphicsLimitInfo,
  isOrgTeam,
  successMessage,
  saveMessage,
  showBackButton,
  onSave,
  onSaveAndCreateAnother,
  onDownload,
}) {
  const navigate = useNavigate();

  // Determine if form is valid based on template type
  const isFormValid = () => {
    if (templateType === 'tryout') {
      return (
        formData.ageGroup &&
        formData.tryoutDate &&
        formData.tryoutTime &&
        formData.location
      );
    } else if (templateType === 'highlight') {
      return formData.highlightPlayer && formData.highlightStats;
    } else {
      return formData.awayTeam;
    }
  };

  const formValid = isFormValid();

  return (
    <>
      <div className="form-actions-save">
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => onSave(true)}
          disabled={!formValid || saving}
        >
          {saving ? 'Saving...' : 'Save Draft'}
        </button>

        {graphicsLimitInfo &&
        !graphicsLimitInfo.unlimited &&
        graphicsLimitInfo.currentGraphics >=
          graphicsLimitInfo.graphicsLimit - 1 &&
        !isOrgTeam ? (
          <button
            type="button"
            className="btn btn-upgrade"
            onClick={() => navigate('/membership')}
            disabled={saving}
          >
            Upgrade for More Graphics
          </button>
        ) : (
          <button
            type="button"
            className="btn btn-primary"
            onClick={onSaveAndCreateAnother}
            disabled={!formValid || saving}
          >
            {saving ? 'Saving...' : 'Save & Create Another'}
          </button>
        )}

        <button
          type="button"
          className="btn btn-primary"
          onClick={onDownload}
          disabled={!formValid || downloading}
        >
          {downloading ? '⏳ Generating...' : '⬇️ Save & Download'}
        </button>
      </div>

      {successMessage && (
        <div className="success-message">{successMessage}</div>
      )}
      {saveMessage && <div className="save-message">{saveMessage}</div>}

      {showBackButton && (
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => navigate(`/team/${formData.selectedTeamId}`)}
        >
          ← Back to Team Portal
        </button>
      )}
    </>
  );
}

export default FormActions;